import {HttpGetConversationsOptions} from '../../http/conversations.http'
import {StyledBadgeButton, StyledConversationFilters} from './style'
import {useTranslation} from '@/translations/i18n'

export const ConversationsFilters = ({
    entityType,
    setEntityType
}: {
    entityType: HttpGetConversationsOptions['params']['entityType'] | null
    setEntityType: (value: HttpGetConversationsOptions['params']['entityType'] | null) => void
}) => {
    const {t} = useTranslation()

    const handleClick = (inputEntityType: NonNullable<HttpGetConversationsOptions['params']['entityType']>) => {
        if (inputEntityType === entityType) {
            setEntityType(null)
        } else {
            setEntityType(inputEntityType)
        }
    }

    return (
        <StyledConversationFilters gap={2}>
            <StyledBadgeButton
                onClick={() => handleClick('project')}
                role="button"
                variant={entityType == 'project' ? 'primary' : 'neutral'}
                shape="rectangle"
            >
                {t('commons:projects', {count: 1})}
            </StyledBadgeButton>
            <StyledBadgeButton
                onClick={() => handleClick('treatment_request')}
                variant={entityType == 'treatment_request' ? 'primary' : 'neutral'}
                role="button"
                shape="rectangle"
            >
                {t('commons:treatment_request')}
            </StyledBadgeButton>
            <StyledBadgeButton
                onClick={() => handleClick('medical_record_report')}
                variant={entityType == 'medical_record_report' ? 'primary' : 'neutral'}
                role="button"
                shape="rectangle"
            >
                {t('global_search:medical_record')}
            </StyledBadgeButton>
        </StyledConversationFilters>
    )
}
